import {
  displayAtomsToHydrate,
  displayAtomsToHydrateCallback,
  filterAtomsToHydrate,
  filterAtomsToHydrateCallback,
} from '@/consts/atomHydration';
import {
  AtomsToHydrate,
  ConfigDisplaySettingKey,
  ConfigDisplaySettings,
  ConfigFilterKey,
  ConfigFilterSet,
} from '@/types/userConfigs';

export const getFilterAtomsToHydrate = (filters: ConfigFilterSet) =>
  Object.entries(filters).map(([key, value]) => {
    const filterKey = key as ConfigFilterKey;
    return [filterAtomsToHydrate()[filterKey], filterAtomsToHydrateCallback[filterKey](value)];
  }) as AtomsToHydrate;

export const getDisplayAtomsToHydrate = (displaySettings: Partial<ConfigDisplaySettings>) =>
  Object.entries(displaySettings).map(([key, value]) => {
    const filterKey = key as ConfigDisplaySettingKey;
    return [displayAtomsToHydrate()[filterKey], displayAtomsToHydrateCallback[filterKey](value)];
  }) as AtomsToHydrate;
